import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import CustomCollection from 'components/CustomCollection';
import ArrowIcon from 'components/Icons/arrow';

export const SearchWrapper = styled.div`
  height: ${scaleSize(1080)}px;
  overflow: hidden;
  position: relative;
  padding-left: ${scaleSize(220)}px;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  display: flex;
  align-items: center;
`;

export const KeyboardWrapper = styled('div')<{ isShow: boolean }>`
  display: ${({ isShow }) => (isShow ? 'none' : 'block')};
  margin-right: ${scaleSize(120)}px;
`;

export const SearchArrow = styled('div')<{ isShow: boolean }>`
  display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
  margin-right: ${scaleSize(120)}px;
  align-items: center;
`;

export const LeftArrowIcon = styled(ArrowIcon)`
  margin-right: ${scaleSize(20)}px;
`;

export const SearchText = styled.div`
  font-size: 34px;
  transform: rotate(270deg);
`;

export const Placeholder = styled.div`
  height: ${scaleSize(600)}px;
  color: ${({ theme }) => theme.secondaryTextColor};
  text-align: center;
  box-sizing: border-box;
  padding-top: ${scaleSize(180)}px;
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${scaleSize(40)}px;
  font-weight: normal;
  line-height: 1.2;
  letter-spacing: normal;

  & > span {
    width: ${scaleSize(550)}px;
    text-align: center;
    margin: 0 auto;
    display: block;
  }

  & > svg {
    width: ${scaleSize(192)}px;
    height: ${scaleSize(192)}px;

    & stroke {
      color: ${({ theme }) => theme.secondaryTextColor};
    }
  }
`;

export const Loading = styled.div`
  width: ${scaleSize(1700)}px;
  height: ${scaleSize(580)}px;
  line-height: ${scaleSize(580)}px;
  text-align: center;
`;

export const StyledCustomCollection = styled(CustomCollection)`
  overflow: hidden;
`;
